/** The default share image (public/og-cardnd.jpg, 1200×630). */
export const DEFAULT_SHARE_IMAGE = 'https://cardnd.com/og-cardnd.jpg';

/**
 * Removes the head tags of `index.html` and the prerendered pages (`data-static-head`, Decision 109), so `<Seo>`'s
 * own tags are the only ones left. Later calls find nothing.
 */
export function removeStaticHead(doc: Document = document) {
  doc.head.querySelectorAll('[data-static-head]').forEach((el) => el.remove());
}
